import CountryId from 'types/CountryID';

export const UNITED_STATES_ID = 313 as CountryId;
export const HAWAII_ID = 366 as CountryId;
